var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9199 6.91935C20.4239 6.33839 20.8083 5.66358 21.0508 4.93366C21.2934 4.20375 21.3893 3.43312 21.3332 2.66602C19.7857 2.79093 18.3492 3.51876 17.3332 4.69268C16.8467 5.25532 16.478 5.90985 16.249 6.61754C16.0199 7.32523 15.9352 8.07167 15.9999 8.81268C16.7547 8.81897 17.5009 8.65148 18.1807 8.32316C18.8604 7.99484 19.4555 7.51451 19.9199 6.91935ZM23.2799 16.8393C23.2888 15.8177 23.5579 14.8151 24.0618 13.9263C24.5657 13.0375 25.2878 12.2917 26.1599 11.7593C25.6095 10.9663 24.8819 10.3125 24.0349 9.84958C23.1878 9.3867 22.2445 9.12755 21.2799 9.09268C19.1999 8.87935 17.2799 10.306 16.1732 10.306C15.0665 10.306 13.5065 9.11935 11.7732 9.14602C10.6401 9.18334 9.53591 9.51372 8.56848 10.1049C7.60105 10.6961 6.80336 11.528 6.25322 12.5193C3.90655 16.5993 5.65322 22.666 7.99988 25.9593C9.06655 27.5727 10.3999 29.3993 12.1599 29.3327C13.9199 29.266 14.4932 28.2393 16.5332 28.2393C18.5732 28.2393 19.1999 29.3327 20.9332 29.2927C22.6665 29.2527 23.8932 27.6393 25.0132 26.026C25.8066 24.8547 26.4264 23.5748 26.8532 22.226C25.7965 21.7754 24.895 21.0251 24.2599 20.0678C23.6249 19.1105 23.2842 17.9881 23.2799 16.8393Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple_logo.0e1dc1cf880f7cb9a5aa285ba32d48c2.svg";
export { ForwardRef as ReactComponent };